<div
  #container
  [ngStyle]="{ 'left.px': position.x, 'top.px': position.y }"
  style="position: absolute; z-index: 100; min-width: 50px"
  class="container"
  elementSize
  (size)="onElementSize($event)"
>
  <ng-content></ng-content>
</div>
